import React from "react";
import * as Icons from "lucide-react";
import { Reveal, Overline } from "../components/site/Reveal";
import { EXECUTION, IMAGES } from "../data/content";

export const Execution = () => (
  <section id="execution" className="relative bg-bg-light py-24 sm:py-32" data-testid="execution-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid items-center gap-14 lg:grid-cols-2">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2rem] card-shadow">
            <img src={IMAGES.execution} alt="Global supply chain execution — container port and trade network" className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-emerald-darkest/60 to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 rounded-2xl bg-emerald-base/90 p-5 text-off-white backdrop-blur">
              <p className="text-xs font-bold uppercase tracking-widest text-gold-light">More than advice</p>
              <p className="mt-1 font-serif text-xl">We advise, and we execute.</p>
            </div>
          </div>
        </Reveal>

        <div>
          <Reveal><Overline>Supply Chain Execution</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-serif text-4xl font-light leading-tight text-charcoal sm:text-5xl">
              Not only a consultancy — a full <span className="text-gradient-emerald">supply chain execution business</span>.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-charcoal/70 sm:text-lg">
              Alongside our advisory work, we operate hands-on across international trade, logistics and end-to-end
              supply chain transactions — supporting clients across goods, services and complete trade flows.
            </p>
          </Reveal>
        </div>
      </div>

      <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {EXECUTION.capabilities.map((c, i) => {
          const Icon = Icons[c.icon] || Icons.Boxes;
          return (
            <Reveal key={c.title} delay={(i % 3) * 0.08}>
              <div data-testid={`execution-cap-${i}`}
                className="group relative h-full overflow-hidden rounded-[1.5rem] border border-black/5 bg-white p-7 card-shadow transition-transform duration-500 hover:-translate-y-1.5">
                <div className="absolute inset-x-0 top-0 h-1 origin-left scale-x-0 bg-gradient-to-r from-emerald-base to-gold transition-transform duration-500 group-hover:scale-x-100" />
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-base p-3.5 text-gold-light transition-colors duration-500 group-hover:bg-gold group-hover:text-emerald-darkest">
                  <Icon size={24} />
                </div>
                <h3 className="mt-5 font-serif text-xl text-charcoal">{c.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-charcoal/65">{c.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
